<template>
  <div class="id-validate data-validate">
    <div class="validate-top">
      <div class="top-left">
        <span class="title">{{barTitle}}</span>
      </div>
      <div class="edit-btn">
        <el-button
          @click="editHandle"
        >{{getSubmitText()}}</el-button>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col
        :sm="12"
        :xs="24"
        class="left-box"
      >
        <div class="data-line">
          <span class="text-box">{{$t('address')}}</span>
          <span class="data-box">{{channelInfo.payDetailMap && channelInfo.payDetailMap.address || '-'}}</span>
        </div>
      </el-col>
      <el-col
        :sm="12"
        :xs="24"
        class="right-col"
      >
        <div class="data-line">
          <span class="text-box">{{$t('QR_code')}}</span>
          <el-image
            v-if="channelInfo.payDetailMap && channelInfo.payDetailMap.qrPic"
            class="usdtkey-img"
            :src="channelInfo.payDetailMap && channelInfo.payDetailMap.qrPic"
            alt=""
            :preview-src-list="[channelInfo.payDetailMap && channelInfo.payDetailMap.qrPic]"
          >
          </el-image>
          <span v-else>-</span>
        </div>
      </el-col>
    </el-row>
    <bar-info-edit-dialog
      :dialog-show="dialogShow"
      :channel-info="channelInfo"
      :bar-title="barTitle"
      @close="closeHandel"
      @ajax-success="ajaxSuccess"
    ></bar-info-edit-dialog>
  </div>
</template>

<script>
import barInfoEditDialog from "@/components/myFiles/collection/barInfoEditDialog";
import { colorRgba } from "@/utils";
export default {
  name: "barInfo",
  components:{
    barInfoEditDialog,
  },
  props: {
    barTitle: {
      default: '',
    },
    channelInfo: {
      type: Object,
      default(){
        return {
          examineStatus: '',
          payDetailMap: {
            address: '',
            qrPic: '',
          }
        }
      },
    },
  },
  data() {
    return {
      yellowColor: '#F29132',
      greenColor: '#41B883',
      redColor: '#D85E5F',
      dialogShow: false,
    }
  },
  methods: {
    getSubmitText(){
      // 有资料就显示'重新绑定',未绑定就显示'绑定'
      if(this.channelInfo && this.channelInfo.payDetailMap && !this.channelInfo.payDetailMap.address){
        return this.$t('bind');
      }else if(this.channelInfo && this.channelInfo.payDetailMap && this.channelInfo.payDetailMap.address){
        return this.$t('User.reBind');
      }
    },
    editHandle(){
      this.dialogShow = true;
    },
    closeHandel(){
      this.dialogShow = false;
    },
    editSuccess(){
      this.dialogShow = false;
    },
    ajaxSuccess(){
      this.dialogShow = false;
      this.$emit('ajax-success');
    }
  },
}
</script>

<style lang="scss" scoped>
.id-validate {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 24px;
  .validate-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .top-left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #5E5873;
    }
  }
  .tag-box-id-validate {
    display: inline-block;
    padding: 2px 5px;
    border-radius: 15px;
    margin-left: 10px;
  }
  .left-box {
    .data-line {
      margin-bottom: 10px;
      .text-box {
        text-align: right;
        color: #A29FAE;
        font-size: 14px;
      }
      .data-box {
        text-align: left;
        color: #5E5873;
        font-size: 14px;
      }
    }
  }
  .right-col {
    .data-line {
      margin-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .text-box {
      text-align: right;
      color: #A29FAE;
    }
  }
  .usdtkey-img {
    width: 80px;
    height: 80px;
  }
}
</style>
